import { CarpetProvider } from "./carpets-contex";
import { PerformanceProvider } from "./performance-context";
import { WinnersProvider } from "./winners-context";

export default function GallerySectionContextProviders({
  data,
  children,
}: {
  data: any;
  children: React.ReactNode;
}) {
  return (
    <PerformanceProvider data={data.performances}>
      <CarpetProvider data={data.lavender_carpet}>
        <WinnersProvider data={data.winners_and_honoraries}>
          {children}
        </WinnersProvider>
      </CarpetProvider>
    </PerformanceProvider>
  );
}
